import React, { useState, useEffect, useCallback, useMemo } from "react";
import Logger from "./Logger";
import Order from "./Order";
import "../Css/Pending.css";
import AssignModal from "./AssignModal";
import PaginationControls from "../Component/Pagination";
import DetailsModal from "./DetailsModal";
import { MdDownloadForOffline, MdOutlineUploadFile } from "react-icons/md";
import { ImUpload } from "react-icons/im";
import OrderLabel from "./OrderLabel";
import { ToastContainer, toast } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import { Tooltip } from "react-tooltip";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Link } from "react-router-dom";
import { Modal, Box, LinearProgress, Typography, CircularProgress, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FaListUl } from "react-icons/fa";
import { connectSocket } from "../utils/connectSocket";
import { getLoggerBaseURL } from "../utils/getLoggerBaseURL";

const Pending = () => {
  const [uploadError, setUploadError] = useState("");
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [orders, setOrders] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDModal, setShowDModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState("OrderNo");
  const [startDate, setStartDate] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const [endDate, setEndDate] = useState(null);
  const [actionType, setActionType] = useState(null);
  const [showLabelModal, setShowLabelModal] = useState(false);
  const [selectedOrdersForLabel, setSelectedOrdersForLabel] = useState([]); // State for showing the label modal
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [selectedOrderIds, setSelectedOrderIds] = useState([]); //for bulk deletion
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showUnassignModal, setShowUnassignModal] = useState(false);
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [selectedOrders, setSelectedOrders] = React.useState([]);
  const [loading, setLoading] = useState(true);
  const userEmail = sessionStorage.getItem("userEmail");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [successSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;
  const [selectedOrderNo, setSelectedOrderNo] = useState(null);
  const [images, setImages] = useState([]);
  const [signature, setSignature] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [openSignatureModal, setOpenSignatureModal] = useState(false);
  const [totalOrders, setTotalOrders] = useState(0);
  const [snackbarMessage] = useState("");
  const [successSnackbarMessage] = useState("");

  const logger = useMemo(() => new Logger(getLoggerBaseURL()), []);

  const role = sessionStorage.getItem("role");
  let permission = {};
  const permissionString = sessionStorage.getItem("permissions");
  if (permissionString) {
    permission = JSON.parse(permissionString);
  } else {
    logger.log("Permission missing", "ERROR");
  }

  useEffect(() => {
    const socket = connectSocket();

    socket.on("success", (order) => {
      setOrders((prevOrders) => {
        const orderIndex = prevOrders.findIndex((o) => o._id === order._id);
        if (orderIndex !== -1) {
          return prevOrders.map((o) =>
            o._id === order._id
              ? { ...order, driverName: order.driverName || o.driverName }
              : o
          );
        } else {
          return [...prevOrders, order];
        }
      });
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const handleOrderDetailsClick = async (orderId) => {
    setSelectedOrderId(orderId);
    setShowDModal(true);
    const selectedOrder = orders.find((order) => order._id === orderId);
    setSelectedOrder(selectedOrder);
  };

  const handleThreeDotsClick = (event, orderId) => {
    if (anchorEl === event.currentTarget) {
      // If the same anchorEl is clicked again, close the dropdown
      setAnchorEl(null);
    } else {
      // Otherwise, set the anchorEl to the clicked element
      setAnchorEl(event.currentTarget);
      setSelectedOrderId(orderId); // Set the selected order ID
    }
  };

  const handleOpenModal = async (orderNo) => {
    const fileName = `${orderNo}.jpg`;
    const encodedFileName = encodeURIComponent(fileName);
    setSelectedOrderNo(encodedFileName);
    setOpenImageModal(true);
    try {
      const response = await fetch(`/api/ordera/image/${encodedFileName}`);
      const data = await response.json();
      if (data.files && data.files.length > 0) {
        setImages(data.files.map(f => f.url));   // only keep the URLs
        setCurrentImageIndex(0);
      } else {
        setImages([]);
      }
    } catch (error) {
      logger.log(`Error fetching images for order ${orderNo}: ${error.message}`, "ERROR");
      setImages([]);
    }
  };

  const handleViewSignature = async (orderNo) => {
    const fileName = `${orderNo}.jpg`;
    const encodedFileName = encodeURIComponent(fileName);
    setSelectedOrderNo(encodedFileName);
    setOpenSignatureModal(true);
    try {
      const sigRes = await fetch(`/api/ordera/signature/${encodedFileName}`);
      if (sigRes.ok) {
        const blob = await sigRes.blob();
        const url = URL.createObjectURL(blob);
        setSignature(url);
      } else {
        setSignature(null);
      }
    } catch (error) {
      logger.log(`Error fetching signature for order ${orderNo}: ${error.message}`, "ERROR");
      setSignature(null);
    }
  };

  const handleOpenAssignModal = () => {
    setShowModal(true);
  };

  const handleOpenLabelModal = (orderIds) => {
    // Ensure that selectedOrder is cleared
    setSelectedOrder(null);

    // Find the selected orders by their IDs and add adminEmail to each
    const selectedOrdersWithEmail = orderIds.map((orderId) => {
      const selectedOrder = orders.find((order) => order._id === orderId);
      return {
        ...selectedOrder,
        adminEmail: userEmail,
      };
    });

    setSelectedOrdersForLabel(selectedOrdersWithEmail); // Set state with selected orders
    setShowLabelModal(true); // Open the label modal
  };

  const handleCompleteOrder = () => { };

  const handleClosecompleteModal = () => {
    setShowCompleteModal(false);
  };

  const downloadErrorMessages = () => {
    const element = document.createElement("a");
    const file = new Blob([uploadError], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "error_messages.txt";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
    document.body.removeChild(element);
    setIsErrorModalOpen(false); // Close the modal after downloading
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setIsUploaded(false);
    setUploadResult(null);
    window.location.reload(); // Refresh the page
  };

  const handleImageUpload = async () => {
    setIsUploading(true);
    const formData = new FormData();
    selectedImages.forEach((image) => formData.append("images", image));

    try {
      const response = await fetch(`/api/ordera/uploadImages/${userEmail}`, {
        method: "POST",
        headers: {
          // Fetch automatically sets the correct boundary for FormData
          // No need to specify 'Content-Type' for FormData with Fetch
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const { successUploads, failedUploads } = data;
      setUploadResult({ successUploads, failedUploads });
      setIsUploaded(true);
    } catch (error) {
      logger.log(`Upload failed: ${error.message}`, "ERROR");
      setUploadResult({
        successUploads: [],
        failedUploads: ["Error occurred during file upload."],
      });
    } finally {
      setIsUploading(false);
    }
  };

  const handleUnassignOrder = async () => {
    try {
      const response = await fetch(`/api/ordera/unassign/${userEmail}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          orderIds: selectedOrderIds,
        }),
      });

      if (response.ok) {
        // Remove the deleted orders from the state
        setOrders(
          orders.filter((order) => !selectedOrderIds.includes(order._id))
        );
        setSelectedOrderIds([]);
        setShowUnassignModal(false); // Close the confirmation modal
        await handleStatusUpdated();
      } else {
        const errorData = await response.json();
        logger.log(`Error cancelling orders: ${errorData.message}`, "ERROR");
      }
    } catch (error) {
      logger.log(`Error cancelling orders: ${error.message}`, "ERROR");
    }
  };

  const handleCloseUnassignModal = () => {
    setShowUnassignModal(false);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSuccessSnackbarOpen(false);
  };

  const handleOpenCompleteModal = (orderId) => {
    setSelectedOrderId(orderId);
    setShowCompleteModal(true);
  };

  const downloadDemoExcel = () => {
    const link = document.createElement("a");
    link.href = "/assets/OldBill.xlsx";
    link.download = "OldBillsSample.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleImageSelection = (event) => {
    const files = Array.from(event.target.files);
    setSelectedImages(files);
    setIsModalOpen(true); // Open the modal after selecting files
  };

  const handleOpenReassignModal = (orderIds) => {
    if (!Array.isArray(orderIds)) {
      // If orderIds is not already an array, wrap it in an array
      orderIds = [orderIds];
    }
    setSelectedOrderIds(orderIds); // Store the array of selected order IDs
    setShowUnassignModal(true); // Open the modal
  };

  const handleViewLabelClick = (orderId) => {
    // Ensure that selectedOrdersForLabel is cleared
    setSelectedOrdersForLabel([]);

    const selectedOrder = orders.find((order) => order._id === orderId);
    const selectedOrderWithEmail = {
      ...selectedOrder,
      adminEmail: userEmail,
    };
    setSelectedOrder(selectedOrderWithEmail);
    setShowLabelModal(true); // Open the label modal
  };

  const handleViewDetailsDropdownClick = (orderId) => {
    const selectedOrder = orders.find((order) => order._id === orderId);
    setSelectedOrder(selectedOrder);
    setShowDModal(true); // Open the details modal
  };

  const handleReassignClick = (orderId) => {
    setSelectedOrderId(orderId);
    setActionType("Reassign");
    setShowModal(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleAssignmentComplete = useCallback(() => {
    setSelectedOrders([]);
  }, [setSelectedOrders]);

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      setSelectedOrders(orders.map((order) => order._id));
    } else {
      setSelectedOrders([]);
    }
  };

  const handleOpenErrorModal = () => {
    setIsErrorModalOpen(true);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("file", file);

    setUploading(true);
    setUploadError(null);
    setUploadProgress(0); // This will not update during upload

    try {
      const response = await fetch(`/api/ordera/api/oldbills/upload/${userEmail}`, {
        method: "POST",
        body: formData,
      }
      );

      const data = await response.json();
      setUploading(false);

      if (response.ok) {
        toast.info("Order Added Successfully");
        setTimeout(() => { window.location.reload(); }, 3000);
      } else {
        const errorMessage = Array.isArray(data.message) ? data.message.join("\n") : data.message || "Incorrect Format";
        setUploadError(errorMessage);
        handleOpenErrorModal();
      }
    } catch (error) {
      setUploading(false);
      setUploadError("An unexpected error occurred while uploading the file.");
    }
  };

  const handleStatusUpdated = useCallback(() => {
    // Fetch the updated orders data from the backend
    const fetchUpdatedOrders = async () => {
      try {
        const response = await fetch(`/api/ordera/pending/${userEmail}`);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        if (data === null || data.length === 0) {
          setOrders([]); // Set orders to an empty array if no data
        } else {
          setOrders(Array.isArray(data.data) ? data.data : []);
          setTotalOrders(data.total || 0);
        }
      } catch (error) {
        logger.log(`Error fetching updated data: ${error.message}`, "ERROR");
      }
    };

    fetchUpdatedOrders();
  }, [logger, userEmail]);

  const handleCloseImageModal = () => {
    setOpenImageModal(false);
    setImages([]);
    setCurrentImageIndex(0);
  };

  const handleCloseSignatureModal = () => {
    setOpenSignatureModal(false);
    setSignature(null);
  };

  const handleAssignClick = useCallback((orderId) => {
    setSelectedOrderId(orderId);
    setActionType("assign");
    setShowModal(true);
  }, []);

  const fetchOrders = useCallback(async (page = 1) => {
    try {
      setLoading(true);

      const params = new URLSearchParams({
        page,
        limit: 50,
        startDate: startDate || "",
        endDate: endDate || "",
        selectedOption,
        keyword: searchQuery || "",
      });

      const res = await fetch(`/api/ordera/pending/${userEmail}?${params.toString()}`);

      const json = await res.json();

      setOrders(json.data);
      setTotalOrders(json.total);
      setCurrentPage(page);
      setLoading(false);
    } catch (error) {
      logger.log(`Error fetching orders for email ${userEmail}: ${error.message}`, "ERROR");
      setOrders([]); // Set orders to an empty array in case of error
    } finally {
      setLoading(false); // Ensure loading state is updated even on error
    }
  }, [startDate, endDate, selectedOption, searchQuery, userEmail, logger]);

  useEffect(() => {
    fetchOrders(1);
  }, [fetchOrders]);

  const handleCloseModal = () => {
    setShowDModal(false);
    setSelectedOrderId(null);
    setSelectedOrder(null);
  };

  const handleSelectOrder = (orderId, isChecked) => {
    if (isChecked) {
      setSelectedOrders([...selectedOrders, orderId]);
    } else {
      setSelectedOrders(selectedOrders.filter((id) => id !== orderId));
    }
  };

  return (
    <div>
      <ToastContainer />
      <Order
        searchQuery={searchQuery}
        setSearchQuery={(val) => {
          setSearchQuery(val);
          setCurrentPage(1);
        }}
        selectedOption={selectedOption}
        setSelectedOption={(val) => {
          setSelectedOption(val);
          setCurrentPage(1);
        }}
        startDate={startDate}
        setStartDate={(val) => {
          setStartDate(val);
          setCurrentPage(1);
        }}
        endDate={endDate}
        setEndDate={(val) => {
          setEndDate(val);
          setCurrentPage(1);
        }}
      />
      <div>
        <div style={{ textAlign: "center", padding: "10px 10px 0px 0px" }}>
          {uploading ? (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh", }}>
              <LinearProgress variant="determinate" value={uploadProgress} style={{ width: "80%", marginBottom: "10px" }} />
              <Typography variant="h6">{`Uploading... ${uploadProgress}%`}</Typography>
            </div>
          ) : loading ? (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh", }}>
              <CircularProgress />
              <Typography variant="h6" style={{ marginTop: "20px" }}>
                Fetching data...
              </Typography>
            </div>
          ) : (
            <>
              {/* Conditionally render the Assign Icon Button */}
              {(role === "admin" ||
                (role === "dispatcher" && permission.assignBulk)) &&
                selectedOrders.length > 0 && (
                  <>
                    <IconButton onClick={handleOpenAssignModal} style={{ position: "fixed", top: "150px", right: "20px", zIndex: 1000, }} data-tooltip-id="assign-tooltip">
                      <Tooltip id="assign-tooltip" place="bottom" content="Assign" />
                      <AddIcon fontSize="large" />
                    </IconButton>

                    <IconButton onClick={() => handleOpenLabelModal(selectedOrders)} style={{ position: "fixed", top: "150px", right: "80px", zIndex: 1000, }} data-tooltip-id="Label-tooltip">
                      <Tooltip id="Label-tooltip" place="bottom" content="Download Labels" />
                      <DownloadIcon fontSize="large" />
                    </IconButton>
                  </>
                )}
              <div className="TotalCu">
                Total Orders: {totalOrders}
              </div>
              <div className="oldbill-actions">
                <div className="oldbills">
                  <button className="choose-file-button-order" onClick={downloadDemoExcel} style={{ cursor: "pointer" }} data-tooltip-id="download-oldbills-tooltip">
                    <MdDownloadForOffline size={30} />
                  </button>
                  <Tooltip id="download-oldbills-tooltip" place="bottom" content="Download Pending Bills Sample Excel" />
                </div>

                <input accept=".xlsx,.xls" style={{ display: "none" }} id="upload-oldbills-file" type="file" onChange={handleFileUpload} autocomplete="off" />
                <label htmlFor="upload-oldbills-file" className="upload-oldbills-file" style={{ cursor: "pointer" }}>
                  <div data-tooltip-id="upload-oldbills-tooltip">
                    <MdOutlineUploadFile size={30} />
                  </div>
                </label>
                <Tooltip id="upload-oldbills-tooltip" place="bottom" content="Upload Pending Bills Excel" />

                <input accept="image/*" style={{ display: "none" }} id="upload-bulk-images" type="file" multiple onChange={handleImageSelection} autocomplete="off" />
                <label htmlFor="upload-bulk-images" className="upload-oldbills-image" style={{ cursor: "pointer" }}>
                  <div data-tooltip-id="upload-bulk-images">
                    <ImUpload size={30} />
                  </div>
                </label>
                <Tooltip id="upload-bulk-images" place="bottom" content="Upload Bulk Images" />
              </div>
              <div className="stickHead">
                <table>
                  <thead>
                    <tr>
                      <th className="Cth">
                        <input type="checkbox" checked={orders.length > 0 && orders.every(order => selectedOrders.includes(order._id))} onChange={(e) => handleSelectAll(e.target.checked)} autocomplete="off" />
                      </th>
                      <th className="Cth">
                        <strong>Order No.</strong>
                      </th>
                      <th className="Cth">
                        <strong>Company Name</strong>
                      </th>
                      <th className="Cth">
                        <strong>Company Address</strong>
                      </th>
                      <th className="Cth">
                        <strong>Total Amount</strong>
                      </th>
                      <th className="Cth">
                        <strong>Due Amount</strong>
                      </th>
                      <th className="Cth">
                        <strong>Distance (in km)</strong>
                      </th>
                      <th className="Cth">
                        <strong>Area</strong>
                      </th>
                      <th className="Cth">
                        <strong>Invoice Date</strong>
                      </th>
                      <th className="Cth">
                        <strong>Invoice Number</strong>
                      </th>
                      <th className="Cth">
                        <strong>Driver</strong>
                      </th>
                      <th className="Cth">
                        <strong>Status</strong>
                      </th>
                      <th className="Cth">
                        <strong>Image</strong>
                      </th>
                      <th className="Cth">
                        <strong>Signature</strong>
                      </th>
                      <th className="Cth">
                        <strong>Actions</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.length === 0 ? (
                      <tr>
                        <td className="noPendingOrders" colSpan="20">
                          <div className="center-content">
                            <div className="icon-wrapper">
                              <FaListUl className="icon" />
                            </div>
                            <span className="noOrdersMsg">
                              No Pending Orders found
                            </span>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      orders
                        .sort((a, b) => {
                          // Convert dates to comparable formats
                          const dateA = new Date(a.creation_date);
                          const dateB = new Date(b.creation_date);
                          return dateB - dateA; // Sorting in decreasing order (newest first)
                        })
                        .map((order) => (
                          <tr key={order._id}>
                            <td className="tdCu">
                              <input type="checkbox" checked={selectedOrders.includes(order._id)} onChange={(e) => handleSelectOrder(order._id, e.target.checked)} autocomplete="off" />
                            </td>
                            <td className="tdCu">
                              <button className="detailsD" onClick={() => handleOrderDetailsClick(order._id)}>
                                <b>{order.Order_No}</b>
                              </button>
                            </td>
                            <td className="tdCu">{order.Rec_Name || "N/A"}</td>
                            <td className="tdCu">{order.Rec_Add || "N/A"}</td>
                            <td className="tdCu">{order.amount}</td>
                            <td className="tdCu">{order.dueamount || "N/A"}</td>
                            <td className="tdCu">{order.distance || "N/A"}</td>
                            <td className="tdCu">{order.area || "N/A"}</td>
                            <td className="tdCu">{order.IDate || "N/A"}</td>
                            <td className="tdCu">{order.INumber || "N/A"}</td>
                            <td className="tdCu">
                              {role === "admin" ||
                                (role === "dispatcher" &&
                                  permission.canAssign) ? (
                                order.o_status === "0" ||
                                  order.o_status === "3" ? (
                                  <button className="assignD" onClick={() => handleAssignClick(order._id)}>
                                    +Assign
                                  </button>
                                ) : (
                                  <span className="assigned">
                                    {order.driverName || "N/A"}
                                  </span>
                                )
                              ) : (
                                <span className="assigned">
                                  {order.driverName || "N/A"}
                                </span>
                              )}
                            </td>
                            <td className="tdCu">
                              {order.o_status === "0" ? (
                                <span className="unassigned">Unassigned</span>
                              ) : order.o_status === "1" ? (
                                <span className="assigned">Assigned</span>
                              ) : order.o_status === "2" ? (
                                <span className="completed">Completed</span>
                              ) : order.o_status === "3" ? (
                                <span className="completed">Incomplete</span>
                              ) : order.o_status === "4" ? (
                                <span className="on way">Picked Up</span>
                              ) : order.o_status === "5" ? (
                                <span className="on way">On the Way</span>
                              ) : (
                                "N/A"
                              )}
                            </td>
                            <td className="tdCu">
                              <button className="detailsDD" onClick={() => handleOpenModal(order.Order_No)}>View Image</button>
                            </td>
                            <td className="tdC">
                              <button className="detailsDD" onClick={() => handleViewSignature(order.Order_No)}>View Signature</button>
                            </td>
                            <td className="tdCu">
                              <button className="Dbutton" onClick={(e) => handleThreeDotsClick(e, order._id)}>
                                ...
                              </button>
                            </td>
                          </tr>
                        ))
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
      {showDModal && (
        <DetailsModal showDModal={showDModal} onClose={() => setShowDModal(false)} selectedOrder={selectedOrder} />
      )}

      {showModal && (
        <AssignModal showModal={showModal} onClose={handleCloseModal} oid={selectedOrderId} actionType={actionType} onStatusUpdated={handleStatusUpdated} selectedOrders={selectedOrders} onAssignmentComplete={handleAssignmentComplete} />
      )}

      <ActionsDropdown anchorEl={anchorEl} onClose={handleCloseMenu} onReassignClick={handleReassignClick} onViewDetailsClick={handleViewDetailsDropdownClick} onLabelClick={handleViewLabelClick} orderId={selectedOrderId} onOpenUnassignModal={handleOpenReassignModal} onOpenCompleteModal={handleOpenCompleteModal} handleCompleteOrder={handleCompleteOrder} role={role} permission={permission} orderStatus={orders.o_status} successSnackbarOpen={successSnackbarOpen} handleSnackbarClose={handleSnackbarClose} successSnackbarMessage={successSnackbarMessage} snackbarOpen={snackbarOpen} snackbarMessage={snackbarMessage} />

      <Dialog open={showUnassignModal} onClose={handleCloseUnassignModal}>
        <DialogTitle>{"Unassign Orders"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {selectedOrderIds.length === 1 ? "Are you sure you want to unassign this order?" : `Are you sure you want to unassign these orders?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseUnassignModal} style={{ backgroundColor: "#79c6e9", border: "1px solid #ccc", color: "#333", borderRadius: "4px", padding: "6px 12px", }}>
            Cancel
          </Button>
          <Button onClick={handleUnassignOrder} style={{ backgroundColor: "#79c6e9", border: "1px solid #79c6e9", color: "white", borderRadius: "4px", padding: "6px 12px", }} autoFocus>
            Unassign
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showLabelModal} onClose={() => setShowLabelModal(false)}>
        <DialogTitle>{"Order Label"}</DialogTitle>
        <DialogContent>
          <OrderLabel orders={selectedOrdersForLabel} selectedOrder={selectedOrder} onClose={() => setShowLabelModal(false)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowLabelModal(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Modal open={isModalOpen} onClose={null} aria-labelledby="modal-title" aria-describedby="modal-description">
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: 400, bgcolor: "background.paper", boxShadow: 24, p: 4, borderRadius: 2, }}>
          <Typography id="modal-title" variant="h6" component="h2" gutterBottom>
            Selected Images
          </Typography>
          <Typography variant="body2" color="warning.main" sx={{ marginBottom: 2 }}>
            * Image name should be the same as Order No.
          </Typography>
          <Typography id="modal-description" variant="body2" gutterBottom>
            {selectedImages.length > 0
              ? selectedImages.map((image, index) => (
                <Typography key={index} sx={{ marginBottom: 1 }}>
                  {index + 1}. {image.name}
                </Typography>
              ))
              : "No images selected."}
          </Typography>
          <Box sx={{ marginTop: 2, display: "flex", justifyContent: "space-between", }}>
            <Button variant="contained" color="primary" onClick={handleImageUpload} disabled={isUploaded}>
              {isUploading ? "Uploading..." : "Upload"}
            </Button>
            <Button variant="outlined" color="secondary" onClick={handleClose}>
              Close
            </Button>
          </Box>
          {uploadResult && (
            <Box sx={{ marginTop: 3 }}>
              <Typography variant="body1" gutterBottom>
                Upload Results:
              </Typography>
              <Typography variant="body2" color="success.main">
                Success:{" "}
                {uploadResult.successUploads.length > 0 ? uploadResult.successUploads.join(", ") : "None"}
              </Typography>
              <Typography variant="body2" color="error.main">
                Failed:{" "}
                {uploadResult.failedUploads.length > 0 ? uploadResult.failedUploads.join(", ") : "None"}
              </Typography>
            </Box>
          )}
        </Box>
      </Modal>

      {/* Error Modal */}
      <Dialog open={isErrorModalOpen} onClose={() => setIsErrorModalOpen(false)}>
        <DialogTitle>Error Messages</DialogTitle>
        <DialogContent>
          <Typography variant="body1" style={{ color: "red" }}>
            {uploadError}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsErrorModalOpen(false)}>Cancel</Button>
          <Button onClick={downloadErrorMessages} variant="contained" color="primary">
            Download Errors
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showCompleteModal} onClose={handleClosecompleteModal}>
        <DialogTitle>{"Complete Order"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {selectedOrderIds.length === 1 ? "Are you sure you want to complete this order?" : `Are you sure you want to complete these orders?`}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClosecompleteModal} style={{ color: "#79c6e9", borderColor: "#79c6e9", border: "1px solid", padding: "6px 16px", borderRadius: "4px", }}>
            Cancel
          </Button>
          <Button
            onClick={() => handleCompleteOrder(selectedOrderId)}
            style={{
              color: "#79c6e9",
              borderColor: "#79c6e9",
              border: "1px solid",
              padding: "6px 16px",
              borderRadius: "4px",
              opacity: 1,
            }}
            autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1rem", marginRight: "30px", }}>
        <PaginationControls totalItems={totalOrders} itemsPerPage={itemsPerPage} currentPage={currentPage} onPageChange={setCurrentPage} />
      </div>

      {/* Image Modal */}
      <Dialog open={openImageModal} onClose={handleCloseImageModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{ textAlign: "center", position: "relative", fontWeight: "bold", }}>
          Proof of Delivery
          <IconButton aria-label="close" onClick={handleCloseImageModal} sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", minHeight: "50vh", }}>
          {images.length > 0 ? (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <img
                src={images[currentImageIndex]}
                alt={`Order ${selectedOrderNo}`}
                loading="lazy"
                style={{
                  maxWidth: "100%",
                  maxHeight: "70vh",
                  objectFit: "contain",
                  display: "block"
                }}
              />
              <div style={{ marginTop: 8, display: "flex", gap: 8, alignItems: "center" }}>
                <Button
                  onClick={() => setCurrentImageIndex(i => Math.max(0, i - 1))}
                  disabled={currentImageIndex === 0}
                >
                  Prev
                </Button>
                <Typography>
                  {currentImageIndex + 1} / {images.length}
                </Typography>
                <Button
                  onClick={() => setCurrentImageIndex(i => Math.min(images.length - 1, i + 1))}
                  disabled={currentImageIndex === images.length - 1}
                >
                  Next
                </Button>
              </div>
            </div>
          ) : (
            <Typography sx={{ textAlign: "center" }}>No image found for this order</Typography>
          )}
        </DialogContent>
      </Dialog>

      {/* Signature Modal */}
      <Dialog open={openSignatureModal} onClose={handleCloseSignatureModal} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ textAlign: "center", position: "relative", fontWeight: "bold" }}>
          Signature
          <IconButton aria-label="close" onClick={handleCloseSignatureModal} sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "50vh", }}>
          {signature ? (
            <img src={signature} alt="Signature" style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain", display: "block", margin: "0 auto", }} />
          ) : (
            <Typography sx={{ textAlign: "center" }}>
              No signature found for this order
            </Typography>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

const ActionsDropdown = ({ anchorEl, onClose, onReassignClick, onViewDetailsClick, onLabelClick, orderId, onOpenUnassignModal, onOpenCompleteModal, role, permission, orderStatus, Mop, Mop2, Mop3, onEditDetailsClick, successSnackbarOpen, handleSnackbarClose, successSnackbarMessage, snackbarOpen, snackbarMessage, }) => {

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        sx={{
          "& .MuiPaper-root": {
            boxShadow: "1px 2px 2px 0px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#fff",
            borderRadius: "8px",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            "&:hover": {
              transform: "scale(1.02)",
              boxShadow: "0px 6px 18px rgba(0, 0, 0, 0.2)",
            },
          },
          "& .MuiMenuItem-root": {
            transition: "background-color 0.3s ease, color 0.3s ease",
            "&:hover": {
              backgroundColor: "#f0f0f0",
              color: "#79c6e9",
            },
          },
        }}
      >
        <MenuItem
          onClick={() => {
            onViewDetailsClick(orderId);
            onClose();
          }}
        >
          View Details
        </MenuItem>
        <MenuItem
          onClick={() => {
            onLabelClick(orderId);
            onClose();
          }}
        >
          View Label
        </MenuItem>
        {role === "admin" ||
          (role === "dispatcher" && permission.completeBill) ? (
          <MenuItem
            onClick={() => {
              onOpenCompleteModal(orderId);
              onClose();
            }}
          >
            Complete Order
          </MenuItem>
        ) : null}
        <MenuItem>
          <Link to={`/timeline/${orderId}`} style={{ textDecoration: "none", color: "inherit" }}          >
            View History
          </Link>
        </MenuItem>
        {role === "admin" || role === "dispatcher" ? (
          <MenuItem
            onClick={() => {
              onOpenUnassignModal(orderId);
              onClose();
            }}
            disabled={orderStatus === 2}
          >
            Unassign
          </MenuItem>
        ) : null}
      </Menu>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert onClose={handleSnackbarClose} severity="error" sx={{ width: "100%", bgcolor: "white", color: "black", border: "2px solid red", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.4)", }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Snackbar open={successSnackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: "100%", bgcolor: "white", color: "black", border: "2px solid green", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.4)", }}>
          {successSnackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Pending;
